import { render, staticRenderFns } from "./VotingRegistrationAutoMatch.vue?vue&type=template&id=450c44b7&"
import script from "./VotingRegistrationAutoMatch.vue?vue&type=script&lang=js&"
export * from "./VotingRegistrationAutoMatch.vue?vue&type=script&lang=js&"
import style0 from "./VotingRegistrationAutoMatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports